import ReactDOM from 'react-dom';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { IntlProvider } from 'react-intl';

import { developerI18n, LOCALES } from '@marketplace/i18n';
import { AuthWithContext } from '@marketplace/common';
import * as routes from '@developer/constants';

import * as serviceWorker from './app/shared/serviceWorker';
import * as history from 'history';
import { Registration } from './features/registration-modal/registration';

import './styles.scss';

// pages
import { LandingPage } from './pages/landing-page';
import { MainPage, mainPageI18n } from './pages/main-page';
import { AppPage, appPageI18n } from './pages/app-page';
import { registrationModalI18n, cardI18n, addEditApplicationModalI18n } from './features';
import { PersonalPage, personalPageI18n } from './pages/personal-page';

import { landingPageI18n } from './pages/landing-page/landing-page.i18n';
import { ApplicationAttributesProvider } from '@developer/portal/context';
import { Completion } from './features/registration-modal/completion';

import { ProtectedRoute } from './app/shared/components';
import { LoginRedirect} from './pages/login-redirect';
import { LandingRedirect } from './pages/landing-redirect';
import { PageNotFound } from './pages/not-found';

const browserHistory = history.createBrowserHistory();

const i18nMessages = {
  ...developerI18n[LOCALES.ENG],
  ...registrationModalI18n[LOCALES.ENG],
  ...addEditApplicationModalI18n[LOCALES.ENG],
  ...appPageI18n[LOCALES.ENG],
  ...mainPageI18n[LOCALES.ENG],
  ...cardI18n[LOCALES.ENG],
  ...landingPageI18n[LOCALES.ENG],
  ...personalPageI18n[LOCALES.ENG],
};

export const app = (
  <IntlProvider locale={LOCALES.ENG} messages={i18nMessages}>
    <AuthWithContext>
      <ApplicationAttributesProvider>
        <Router history={browserHistory}>
          <Switch>
            <ProtectedRoute exact path={routes.ROUTE_DEVELOPER_DASHBOARD} component={MainPage} />
            <ProtectedRoute exact path={routes.ROUTE_DEVELOPER_DASHBOARD_APPLICATION} component={AppPage} />
            <ProtectedRoute exact path={routes.ROUTE_DEVELOPER_DASHBOARD_MY_PROFILE} component={PersonalPage} />
            <Route exact path={routes.ROUTE_DEVELOPER_REGISTRATION} component={Registration} />
            <Route exact path={routes.ROUTE_DEVELOPER_REGISTRATION_CONFIRMATION} component={Completion} />
            <Route path={routes.ROUTE_DEVELOPER_LANDING_REDIRECT} component={LandingRedirect} />
            <Route path={routes.ROUTE_DEVELOPER_LOGIN} component={LoginRedirect} />
            <Route path={routes.ROUTE_404} component={PageNotFound} />
            <Route path={routes.ROUTE_DEVELOPER} component={PageNotFound} />
            <Route path="*" render={PageNotFound} />
          </Switch>
        </Router>
      </ApplicationAttributesProvider>
    </AuthWithContext>
    <div hidden>{process.env.NX_BUILD_NUMBER}</div>
  </IntlProvider>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
